import React, { useMemo } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { checkAPiHealth } from '../../services/authService';
import { appProperties } from '../../util/appProperties';
import Countdown from 'react-countdown';
import moment from 'moment';
import { NavLink } from 'react-router-dom';
import { AppContextProvider } from '../../contexts/AppContext';
import { checkCurrentUserAccountStatus } from '../../common/userStatusChecker';
import { toast } from 'react-toastify';

const PageLayout = ({ children, instance }) => {
  const [currentUserAccountStatus, setCurrentUserAccountStatus] = useState(null);
  const isECertificateFeatureAllowed = useMemo(() => {
    return appProperties.eCertificateFeatureAllowedCountries.includes(appProperties.applicationHostedRegion);
  }, []);

  const checkBackend = async () => {
    try {
      await checkAPiHealth();
    } catch (error) {
      setNotifications(appProperties.serviceUnavailable);
    }
  };

  const setNotifications = (message) => {
    toast.error(message);
    window.scrollTo(0, 0);
  };

  // Renderer callback with condition
  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (!completed) {
      return (
        <span className="countdown">
          {hours}h {minutes}m {seconds}s
        </span>
      );
    }
  };

  useEffect(() => {
    checkBackend();
    if (instance.getAllAccounts().length > 0) {
      const getStatus = async () => {
        try {
          const result = await checkCurrentUserAccountStatus(instance);
          setCurrentUserAccountStatus(result);
        } catch (e) {
          setNotifications(e);
        }
      };
      getStatus();
    }
    //eslint-disable-next-line
  }, []);

  const showAccountDeletionTime =
    currentUserAccountStatus?.isUserExist && currentUserAccountStatus?.isUserDeleteRequested
      ? moment
          .utc(new Date(currentUserAccountStatus?.userDeleteExecutionTime).toString())
          .local()
          .format('YYYY-MM-DDTHH:mm:ss')
      : null;

  return (
    <div className={showAccountDeletionTime ? 'page-layout delete-nav' : 'page-layout'}>
      <AppContextProvider
        value={{
          currentUserAccountStatus,
          setCurrentUserAccountStatus,
          isECertificateFeatureAllowed
        }}
      >
        {showAccountDeletionTime && (
          <div className="account-delete-notification">
            <span>Your account will be deleted in</span>
            <Countdown date={showAccountDeletionTime} renderer={renderer} />
            {window.location.pathname !== '/myprofile' && (
              <span>
                <NavLink to="/myprofile">Recover Account</NavLink>
              </span>
            )}
          </div>
        )}
        {children}
      </AppContextProvider>
    </div>
  );
};

export default PageLayout;
